const pushDataLayerEvent = (payload = {}) => {
	if (typeof window === "undefined") {
		return;
	}

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(payload);
};

export default pushDataLayerEvent;
